import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

// Components
import Loading from '../../components/Loading';

// Icons
import UploadIcon from '../../assets/icons/upload-cloud-icon.inline.svg';

const messages = defineMessages({
  dropzonePlaceholder: {
    id: 'cc4.form.direct-feedback-dropzone.file.placeholder',
    defaultMessage: '<primary>Upload</primary> or drag here',
  },
  uploadFile: {
    id: 'cc4.form.direct-feedback-dropzone.upload-file',
    defaultMessage: '<primary>Upload</primary> or take photo',
  },
  pleaseSelectCategoryInfo: {
    id: 'cc4.form.upload-other-document.please-select-category-info',
    defaultMessage: 'Please select category',
  },
});

const DropzonePlaceholder = ({
  formatMessage,
  fileIsUploading,
  categoryId,
}) => {
  return (
    <>
      <div className="sm:hidden flex h-full py-15 justify-center items-center bg-white">
        <div className="flex flex-col justify-center items-center">
          {fileIsUploading ? (
            <Loading />
          ) : (
            <>
              <UploadIcon className="fill-primary" />
              <p>
                {formatMessage(messages.uploadFile, {
                  // eslint-disable-next-line
                  primary: (...chunks) => (
                    <span className="text-primary-400">{chunks}</span>
                  ),
                })}
              </p>
            </>
          )}
        </div>
      </div>
      <div className="hidden sm:flex h-full justify-center items-center p-20 flex-col sm:h-150 bg-primary-05">
        {fileIsUploading ? (
          <Loading />
        ) : (
          <>
            <UploadIcon className="fill-primary" />
            <p className="mt-10">
              {categoryId
                ? formatMessage(messages.dropzonePlaceholder, {
                    // eslint-disable-next-line
                    primary: (...chunks) => (
                      <span className="text-primary-400">{chunks}</span>
                    ),
                  })
                : formatMessage(messages.pleaseSelectCategoryInfo)}
            </p>
          </>
        )}
      </div>
    </>
  );
};

DropzonePlaceholder.propTypes = {
  categoryId: PropTypes.string,
  fileIsUploading: PropTypes.bool.isRequired,
  formatMessage: PropTypes.func.isRequired,
};

export default DropzonePlaceholder;
